module.exports = __webpack_public_path__ + "img/N134-1.56f37ee1.png";